import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SimInitialsPipe } from '@simOn/common/pipes';
import { UserStatus, avatarColor } from '@simOn/common/user-info-card-models';

@Component({
  selector: 'sim-event-avatar',
  imports: [SimInitialsPipe],
  templateUrl: './event-avatar.component.html',
  styleUrl: './event-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'event-avatar',
    '[style.background-color]': 'color()',
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()'
  }
})
export class EventAvatarComponent {
  readonly name = input<string>('');
  readonly seed = input<string>('');
  readonly size = input<number>(32);
  readonly status = input<UserStatus | undefined>(undefined);

  protected readonly color = computed(() => avatarColor(this.seed() || this.name(), this.status()));
}
